var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 1.71094H1.00028C0.921708 1.71094 0.857422 1.77522 0.857422 1.85379V2.99665C0.857422 3.07522 0.921708 3.13951 1.00028 3.13951H15.0003C15.0789 3.13951 15.1431 3.07522 15.1431 2.99665V1.85379C15.1431 1.77522 15.0789 1.71094 15.0003 1.71094ZM15.0003 12.8538H1.00028C0.921708 12.8538 0.857422 12.9181 0.857422 12.9967V14.1395C0.857422 14.2181 0.921708 14.2824 1.00028 14.2824H15.0003C15.0789 14.2824 15.1431 14.2181 15.1431 14.1395V12.9967C15.1431 12.9181 15.0789 12.8538 15.0003 12.8538ZM15.0003 7.28237H1.00028C0.921708 7.28237 0.857422 7.34665 0.857422 7.42522V8.56808C0.857422 8.64665 0.921708 8.71094 1.00028 8.71094H15.0003C15.0789 8.71094 15.1431 8.64665 15.1431 8.56808V7.42522C15.1431 7.34665 15.0789 7.28237 15.0003 7.28237Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.247c927d7f049cc6a6f97fe68851df97.svg";
export { ForwardRef as ReactComponent };